import React from "react";
import {Link} from "react-router";

import {Button} from "@material-ui/core";

import {OrganisationId} from "common/types/organisation";
import {buildQuery} from "utils/uri";

type Props = {
  organisationId: OrganisationId;
  definitionId?: string | number | null;
  configId?: string | number | null;
  projectId?: string | number | null;
  documentId?: string | number | null;
};

export default function TestListLinnk({
  organisationId,
  definitionId,
  configId,
  projectId,
  documentId,
}: Props) {
  const filters = {
    ...(definitionId ? {workflow: definitionId} : {}),
    ...(configId ? {config: configId} : {}),
    ...(projectId ? {project: projectId} : {}),
    ...(documentId ? {document: documentId} : {}),
  };
  return (
    <Link
      to={`/organisation/${organisationId}/llm-tests${buildQuery(filters)}`}
    >
      <Button variant="outlined" primary={true}>
        Tests
      </Button>
    </Link>
  );
}
